import { ShiftType, TaskDocumentationState, values, ExecutionProofType } from '../../../enums';
import * as yup from 'yup';
import { IUser } from '../../../common';
import {
  CreateNursingReportFormSchema,
  INursingReportForm,
} from '../nursing-report/INursingReportForm';

export const ExecutionProofDocumentationSchema = yup.object({
  date: yup.date().required(),
  type: yup.mixed<ExecutionProofType>().oneOf(values(ExecutionProofType)).required(),
  shift: yup.mixed<ShiftType>().oneOf(values(ShiftType)).required(),
  state: yup
    .mixed<TaskDocumentationState>()
    .oneOf([TaskDocumentationState.DONE, TaskDocumentationState.DEVIATION])
    .required(),
});

export const CreateExecutionProofDocumentationSchema = yup
  .object({
    nursingReport: CreateNursingReportFormSchema.notRequired().default(undefined),
    // TODO: create new Task or require existing ID
    // nursingTask: CreateNursingTaskSchema,
  })
  .concat(ExecutionProofDocumentationSchema);

// Documentation object that can be connected to a specific (active) task giving information about task completion date & time and the outcome / state of the task
export interface IExecutionProofDocumentation {
  /**
   * The date, which the documentation belongs to.
   */
  date: Date;
  /**
   * The shift, which the documentation belongs to.
   */
  shift: ShiftType;
  /**
   * Type of the Execution (i.e. what kind of task was fulfilled)
   */
  type: ExecutionProofType;
  /**
   * The Resident that fulfilled the Task.
   */
  residentId?: string;
  /**
   * The User that fulfilled the Task.
   */
  documentedBy?: IUser;
  documentedById?: string;
  /**
   * The Timestamp where the Task has been completed.
   */
  documentedAt?: Date;
  /**
   * The current state of the Execution Proof
   */
  state: TaskDocumentationState;
  /**
   * The Nursing-Report that has to be created if the execution has deviated.
   */
  nursingReportId?: string;
  nursingReport?: INursingReportForm;
}
